<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true"
          >บันทึกข้อมูลเรียบร้อย !</v-alert
        >
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <v-form ref="form">
          <div class="pa-2">
            <v-card-text>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา"
                single-line
                hide-details
              ></v-text-field>
            </v-card-text>
            <v-data-table
              :items="productList"
              item-key="id"
              sort-by="id"
              group-by="id"
              class="elevation-1"
              show-group-by
              hide-default-header
              hide-default-footer
            >
              <template v-slot:group.header="{ items, isOpen, toggle }">
                <th>
                  <v-icon @click="toggle">
                    {{ isOpen ? "mdi-minus" : "mdi-plus" }}
                  </v-icon>
                </th>
                <th class="txt-header">
                  รหัสสินค้า : {{ items?.[0].product_code }}
                </th>
                <th class="txt-header">บาร์โค้ด : {{ items?.[0].barcode }}</th>
                <th class="txt-header" colspan="2">
                  ชื่อสินค้า : {{ items?.[0].name }}
                </th>
                <th class="txt-header" style="text-align: end">
                  หน่วยนับ : {{ items?.[0].unit_name }}
                </th>
              </template>

              <template v-slot:item="{ item }">
                <tr v-for="data in item.list" :key="data.id">
                  <td class="txt-item" colspan="3">{{ data.name }}</td>
                  
                  <td class="pt-2 pb-2">
                    <!-- @blur="save_price_standard(data.id, data.price_standard)" -->
                    <v-text-field
                      v-model="data.price_standard"
                      hide-details="auto"
                      label="ราคาขายปลีก"
                      @keypress="isCurrency($event, data.price_standard)"
                      prepend-inner-icon="mdi-currency-thb"
                      color="#8cc63e"
                      outlined
                      dense
                      single-line
                      :rules="[
                        (v) =>
                          v === '' || item.storage_type !== null
                            ? 'ราคาขายปลีก'
                            : true,
                      ]"
                    >
                    </v-text-field>
                  </td>
                  
                  <td>
                    <!-- @blur="save_price_register(data.id, data.price_register)" -->
                    <v-text-field
                      v-model="data.price_register"
                      hide-details="auto"
                      label="ราคาสมาชิก"
                      @keypress="isCurrency($event, data.price_register)"
                      prepend-inner-icon="mdi-currency-thb"
                      color="#8cc63e"
                      outlined
                      dense
                      single-line
                      :rules="[
                        (v) =>
                          v === '' || item.storage_type !== null
                            ? 'ราคาสมาชิก'
                            : true,
                      ]"
                    >
                    </v-text-field>
                  </td>

                  <td>
                    <!-- @blur="save_price_employee(data.id, data.price_employee)" -->
                    <v-text-field
                      v-model="data.price_employee"
                      hide-details="auto"
                      label="ราคาพนักงาน"
                      @keypress="isCurrency($event, data.price_employee)"
                      prepend-inner-icon="mdi-currency-thb"
                      color="#8cc63e"
                      outlined
                      dense
                      single-line
                      :rules="[
                        (v) =>
                          v === '' || item.storage_type !== null
                            ? 'ราคาพนักงาน'
                            : true,
                      ]"
                    >
                    </v-text-field>
                  </td>

                </tr>
              </template>

            </v-data-table>

            <div class="pa-0 text-center mt-4 mb-2">
              <v-btn x-large  @click="saveAllPricesBulk" class="grad-success-bg white--text" style="font-size: 18px">บันทึก</v-btn>
            </div>

            <v-pagination v-if="productList.length !== 0" class="mt-4 mb-4" v-model="page" :length="num_pages"
              :total-visible="20" circle color="#8cc63e"></v-pagination>
          </div>

         

        </v-form>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
import { isTelephone, onlyForCurrency } from "@/js/handler";
import { HTTP } from "@/axios";
import { HTTP_ARIN } from "@/axios_arin";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Contact_information",
  data() {
    return {
      loading_page: false,
      overlay: false,
      alert_success: false,
      productList: [],
      page: 1,
      num_pages: 1,
      size: 10,
      search: "",
      searchTimer: null,
      setProductPriceEmployee: [],
    };
  },
  methods: {
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number);
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number);
    },
    // ฟังค์ชั่น การแสดงสินค้า
    async getShow_product() {
      if (this.$store.state.access_token === null) {
        this.$store.commit("logout_success");
        this.$router.push("/login");
      } else {
        HTTP_ARIN.get(
          `/setuppos/getmainstoreproduct?page=${this.page}&size=${this.size}&search=${this.search}`
        ).then((res) => {
          if (res.data.successful === true) {
            this.loading_page = false;
            this.productList = res.data.data;
            this.num_pages = parseInt(res.data.page);
            this.page = parseInt(res.data.current_page);
            let price_register = res.data.price_register
              ? res.data.price_register
              : Math.ceil(parseFloat(res.data.retail_price) * 1.05);
            console.log(price_register);
            console.log(this.productList);
            this.$nextTick(() => {
              this.checkValidity();
            });
          }
        });
      }
    },
    saveAllPrice(item) {
      const payload = {
        id: item.id,
        price_standard: item.price_standard || 0,
        price_register: item.price_register || 0,
        price_employee: item.price_employee || 0,
      };

      HTTP_ARIN.post("/setuppos/updateprice", payload).then((res) => {
        if (res.data.successful === true) {
          this.alert_success = true;
          this.getShow_product();
          setTimeout(() => (this.alert_success = false), 3000);
        }
      });
    },

    saveAllPricesBulk() {
      this.overlay = true;
      const payload = [];

      // Loop ทุกกลุ่มสินค้า
      this.productList.forEach((product) => {
        product.list.forEach((item) => {
          payload.push({
            id: item.id,
            price_standard: item.price_standard || 0,
            price_register: item.price_register || 0,
            price_employee: item.price_employee || 0,
          });
        });
      });

      // ส่งทั้งหมดไป backend
      HTTP_ARIN.post("/setuppos/updateprice/multiple", payload)
        .then((res) => {
          if (res.data.successful) {
            this.alert_success = true;
            this.getShow_product();
            setTimeout(() => (this.alert_success = false), 3000);
          }
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    
    // price_standard
    save_price_standard(id, price) {
      price = price == "" ? 0 : price;
      HTTP_ARIN.post("/setuppos/updateprice", {
        id: id,
        price_standard: price,
      }).then((res) => {
        if (res.data.successful === true) {
          // this.overlay = false
          this.alert_success = true;
          this.getShow_product();
          setTimeout(() => (this.alert_success = false), 3000);
        }
      });
    },
    // price_register
    save_price_register(id, price) {
      price = price == "" ? 0 : price;
      HTTP_ARIN.post("/setuppos/updateprice", {
        id: id,
        price_register: price,
      }).then((res) => {
        if (res.data.successful === true) {
          // this.overlay = false
          this.alert_success = true;
          this.getShow_product();
          setTimeout(() => (this.alert_success = false), 3000);
        }
      });
    },
    // price_employee
    save_price_employee(id, price) {
      price = price == "" ? 0 : price;
      HTTP_ARIN.post("/setuppos/updateprice", {
        id: id,
        price_employee: price,
      }).then((res) => {
        if (res.data.successful === true) {
          // this.overlay = false
          this.alert_success = true;
          this.getShow_product();
          setTimeout(() => (this.alert_success = false), 3000);
        }
      });
    },
    checkValidity() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        return false;
      }
    },
    getProduct_list(id) {
      HTTP.post("/products/productlist/show/" + id).then((res) => {
        if (res.data.success === true) {
          this.setProductPriceEmployee = res.data.set_product_price[1].rate_5;
          console.log("setProductPriceEmployee", this.setProductPriceEmployee);
        }
      });
    },
  },
  mounted() {
    this.getShow_product();
    this.$nextTick(() => {
      this.checkValidity();
    });
  },
  watch: {
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getShow_product();
      }, 500);
    },
    page() {
      this.getShow_product();
    },
  },
};
</script>

<style scoped>
.txt-header {
  color: #383838 !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 300 !important;
  line-height: normal !important;
}

.txt-item {
  color: #383838 !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 300 !important;
  line-height: normal !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}

.mobile_btn {
  width: 30%;
}

@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}

@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
